import React, { useEffect, useState } from 'react';
import './css/index.scss';
import Api from '../../../../Api';
import sendRequest from '../../../../helpers/sendRequest';

function SelectEventCategory({ setValue, setTempComponentState }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      const data = await sendRequest({
        request: Api.getEventCategories,
        warnErrorText: 'while getting event categories',
        setLoading,
      });

      if (data?.status === 'ok') {
        setCategories(data.categories || []);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    setValue(category);
    setTempComponentState(null);
  };

  if (loading) {
    return (
      <div className="temp_container">
        <p className="temp_container_title">Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="temp_container">
      <p className="temp_container_title">Выберите категорию события</p>
      <div className="temp_container_scroll">
        {categories.map((item) => (
          <div
            key={item._id}
            className="temp_container_item"
            onClick={() => handleCategoryClick(item)}
          >
            <p className="temp_container_item_text">{item.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SelectEventCategory;

